import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faShoppingCart, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Card, Button, Spinner, Form, Alert } from '@themesberg/react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Context } from "../../../../context/Context";
import { CartContext } from '../../../../context/CartContext'; // Importar CartContext
import axios from '../../../../config/axios';
import PaginationComponent from '../../../widgets/PaginationComponent';
import { truncateText } from '../../../utils/format-text';
import placeholderImage from '../../../../assets/img/placeholders/placeholder-image.png';
import { ProductDetailModal } from '../../modals/catalog/productDetail';

export const CatalogCardClient = ({ searchTerm, channel, state, product_type, status, sync, price_list_id }) => {
    const navigate = useNavigate();
    const [auth] = useContext(Context);
    const { addToCart } = useContext(CartContext); // Usar CartContext
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalData, setTotalData] = useState(0);
    const [selectedVariants, setSelectedVariants] = useState({});
    const [selectedQuantities, setSelectedQuantities] = useState({});
    const [alerts, setAlerts] = useState({}); // Estado para alertas individuales
    const [showDefault, setShowDefault] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const limit = 50;

    useEffect(() => {
        if (auth?.id) {
            fetchData();
        }
}, [auth, searchTerm, channel, state, product_type, status, page, price_list_id]);

    const fetchData = async () => {
        setLoading(true);
        try {
            let url = '';

            if (auth.role === 'client') {
                if (price_list_id) {
                    url = `/product/catalog/list/pricelist/${price_list_id}`;
                } else {
                    url = `/product/list/client/${auth.id}`;
                }
            } else if (auth.role === 'admin') {
                url = `/product/catalog/list/pricelist/${price_list_id}`;
            }

            const { data: response } = await axios.get(url, {
                params: { search: searchTerm, channel, state, product_type, status, page, limit }
            });

            setData(response.rows || []);
            console.log("Datos recuperados:", response.rows);
            
            setTotalData(response.total || 0);
            sync && sync(response.rows || []);
        } catch (error) {
            console.error("Error al recuperar los datos:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleShowDetails = (id) => {
        setSelectedId(id);
        setShowDefault(true);
    };

    const handleClose = () => {
        setShowDefault(false);
        setSelectedId(null); // Restablece el ID seleccionado cuando se cierra el modal
    };

    const handleVariantChange = (productId, variant) => {
        setSelectedVariants({ ...selectedVariants, [productId]: variant });
    };

    const handleQuantityChange = (productId, quantity, maxQuantity) => {
        if (quantity > maxQuantity) {
            setAlerts({
                ...alerts,
                [productId]: `Solo hay ${maxQuantity} unidades disponibles.`
            });

            setTimeout(() => {
                setAlerts(prevAlerts => {
                    const newAlerts = { ...prevAlerts };
                    delete newAlerts[productId];
                    return newAlerts;
                });
            }, 3000);

            setSelectedQuantities({ ...selectedQuantities, [productId]: maxQuantity });
        } else {
            setSelectedQuantities({ ...selectedQuantities, [productId]: quantity });
        }
    };

    const handleAddToCart = (productId) => {
        const selectedVariant = selectedVariants[productId] || data.find(item => item.id === productId)?.variants?.[0];
        const availableQuantity = selectedVariant?.inventory_quantity || 0;
        const selectedQuantity = selectedQuantities[productId] ?? 1;

        if (selectedQuantity <= 0 || selectedQuantity > availableQuantity) {
            setAlerts({
                ...alerts,
                [productId]: `Debes seleccionar entre 1 y ${availableQuantity} unidades.`
            });

            setTimeout(() => {
                setAlerts(prevAlerts => {
                    const newAlerts = { ...prevAlerts };
                    delete newAlerts[productId];
                    return newAlerts;
                });
            }, 3000);

            return;
        }

        // Si la variante es "Default Title", solo pasamos el nombre del producto
        const itemToAdd = {
            productId,
            variant: {
                ...selectedVariant,
                title: selectedVariant.title === "Default Title" ? data.find(item => item.id === productId)?.title : selectedVariant.title
            },
            quantity: selectedQuantity
        };

        addToCart(itemToAdd);

        setAlerts({
            ...alerts,
            [productId]: "Producto agregado al carrito"
        });

        setTimeout(() => {
            setAlerts(prevAlerts => {
                const newAlerts = { ...prevAlerts };
                delete newAlerts[productId];
                return newAlerts;
            });
        }, 3000);
    };

    return (
        <>
            <Card border="light" className="table-wrapper table-responsive shadow-sm">
                <Card.Body className="pt-0">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                            <Spinner animation="border" role="status" />
                            <span className="visually-hidden">Cargando...</span>
                        </div>
                    ) : (
                        <div className="row">
                            {data.length > 0 ? (
                                data.map(item => {
                                    const selectedVariant = selectedVariants[item.id] || item.variants?.[0];
                                    const availableQuantity = selectedVariant?.inventory_quantity || 0;
                                    console.log(availableQuantity);

                                    return (
                                        <div key={item.id} className="col-12 col-md-6 col-lg-4 mb-4 mt-4">
                                            <Card className="shadow-sm">
                                                <Card.Img
                                                    variant="top"
                                                    src={selectedVariant?.images?.[0] || placeholderImage}
                                                    alt={item.title}
                                                    onError={(e) => e.target.src = placeholderImage}
                                                    style={{ height: '200px', objectFit: 'cover' }}
                                                />
                                                <Card.Body>
                                                    <h5 className="card-title">
                                                        {truncateText(item.title)}
                                                    </h5>
                                                    <p className="card-text">Proveedor: {item.vendor}</p>
                                                    <p className="card-text">Tipo: {item.product_type}</p>

                                                    {/* Sección de alertas dentro del widget de la carta */}
                                                    {alerts[item.id] && (
                                                        <Alert variant={alerts[item.id].includes("agregado") ? "success" : "warning"} className="p-2 text-center">
                                                            <FontAwesomeIcon icon={alerts[item.id].includes("agregado") ? faShoppingCart : faExclamationTriangle} /> {alerts[item.id]}
                                                        </Alert>
                                                    )}

                                                    <Button variant="primary w-100" onClick={() => handleShowDetails(item.id)}>
                                                        <FontAwesomeIcon icon={faEye} /> Ver detalles
                                                    </Button>

                                                    <Form.Select
                                                        className="mt-2"
                                                        onChange={(e) => handleVariantChange(item.id, JSON.parse(e.target.value))}
                                                        defaultValue={JSON.stringify(selectedVariant)}
                                                    >
                                                        {item.variants?.map(variant => (
                                                            <option key={variant.id} value={JSON.stringify(variant)}>
                                                                {variant.title === "Default Title"
                                                                    ? `${item.title} - $${variant.price}`
                                                                    : `${variant.title} - $${variant.price}`
                                                                }
                                                            </option>
                                                        ))}
                                                    </Form.Select>

                                                    <Form.Control
                                                        type="number"
                                                        min="1"
                                                        max={availableQuantity}
                                                        className="mt-2"
                                                        value={selectedQuantities[item.id] ?? 1} // Si es undefined, usar 1
                                                        onChange={(e) => handleQuantityChange(item.id, parseInt(e.target.value, 10), availableQuantity)}
                                                    />

                                                    <Button variant="success w-100" className="mt-2" onClick={() => handleAddToCart(item.id)}>
                                                        <FontAwesomeIcon icon={faShoppingCart} /> Agregar al carrito
                                                    </Button>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="col-12 text-center">No se encontraron productos.</div>
                            )}
                        </div>
                    )}
                </Card.Body>
                <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
                    <PaginationComponent
                        currentPage={page}
                        totalItems={totalData}
                        limit={limit}
                        onPageChange={setPage}
                    />
                    <small className="fw-bold">
                        Mostrando <b>{Math.min((page - 1) * limit + 1, totalData)}-{Math.min(page * limit, totalData)}</b> de un total de <b>{totalData}</b> productos
                    </small>
                </Card.Footer>
            </Card>
            <ProductDetailModal show={showDefault} handleClose={handleClose} selectedId={selectedId} />
        </>
    );
};

export default CatalogCardClient;